export const formatAddress = ({ address } = {}) => {
    if (!address) return '-';
    const floor = address.floor ? `, кв. ${address.floor}` : '';
    return [
        address.suburb || address.city?.name_ua,
        address.street, 
        `${address.house_number} ${floor}`,
    ].filter(x => !!x).join(', ');
}
